import React from 'react';
import './LegalAdvice.scss';

export const LegalAdvice: React.FC = () => {
  return (
    <div className="legal-advice">
      <h1>AVISO LEGAL</h1>
      <h2>LEY DE LOS SERVICIOS DE LA SOCIEDAD DE LA INFORMACIÓN (LSSI)</h2>

      <p>
        LENDIT S.L., responsable del sitio web, en adelante RESPONSABLE, pone a disposición de los usuarios el presente
        documento, con el que pretende dar cumplimiento a las obligaciones dispuestas en la Ley 34/2002, de 11 de julio,
        de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSICE), BOE N.º 166, así como informar
        a todos los usuarios del sitio web respecto a cuáles son las condiciones de uso.
      </p>

      <p>
        Toda persona que acceda a este sitio web asume el papel de usuario, comprometiéndose a la observancia y
        cumplimiento riguroso de las disposiciones aquí dispuestas, así como a cualquier otra disposición legal que fuera
        de aplicación.
      </p>

      <p>
        LENDIT S.L. se reserva el derecho de modificar cualquier tipo de información que pudiera aparecer en el sitio web,
        sin que exista obligación de preavisar o poner en conocimiento de los usuarios dichas obligaciones, entendiéndose
        como suficiente con la publicación en el sitio web de LENDIT S.L.
      </p>

      <h3>1. DATOS IDENTIFICATIVOS</h3>
      <p>
        Denominación del titular: <strong>LENDIT S.L.</strong><br />
        Domicilio: B/Caceo 7, Molledo, 39430, España<br />
        CIF: B70958756<br />
        Correo electrónico: lenditsl@gmail.com<br />
        Registro Mercantil de Santander
      </p>

      <h3>2. OBJETO</h3>
      <p>
        A través del Sitio Web, les ofrecemos a los Usuarios la posibilidad de acceder a la información sobre nuestros
        servicios.
      </p>

      <h3>3. PRIVACIDAD Y TRATAMIENTO DE DATOS</h3>
      <p>
        Cuando para el acceso a determinados contenidos o servicios sea necesario facilitar datos de carácter personal,
        los Usuarios garantizarán su veracidad, exactitud, autenticidad y vigencia. La empresa dará a dichos datos el
        tratamiento automatizado que corresponda en función de su naturaleza o finalidad, en los términos indicados en la
        sección de Política de Privacidad.
      </p>

      <h3>4. PROPIEDAD INTELECTUAL E INDUSTRIAL</h3>
      <p>
        El Usuario reconoce y acepta que todos los contenidos que se muestran en el Espacio Web y en especial, diseños,
        textos, imágenes, logos, iconos, botones, software, nombres comerciales, marcas, o cualesquiera otros signos
        susceptibles de utilización industrial y/o comercial están sujetos a derechos de Propiedad Intelectual y todas
        las marcas, nombres comerciales o signos distintivos, todos los derechos de propiedad industrial e intelectual,
        sobre los contenidos y/o cualesquiera otros elementos insertados en el página, que son propiedad exclusiva de la
        empresa y/o de terceros, quienes tienen el derecho exclusivo de utilizarlos en el tráfico económico. Por todo
        ello el Usuario se compromete a no reproducir, copiar, distribuir, poner a disposición o de cualquier otra forma
        comunicar públicamente, transformar o modificar tales contenidos manteniendo indemne a la empresa de cualquier
        reclamación que se derive del incumplimiento de tales obligaciones.
      </p>
      <p>
        En ningún caso el acceso al Espacio Web implica ningún tipo de renuncia, transmisión, licencia o cesión total ni
        parcial de dichos derechos, salvo que se establezca expresamente lo contrario. Las presentes Condiciones
        Generales de Uso del Espacio Web no confieren a los Usuarios ningún otro derecho de utilización, alteración,
        explotación, reproducción, distribución o comunicación pública del Espacio Web y/o de sus Contenidos distintos de
        los aquí expresamente previstos. Cualquier otro uso o explotación de cualesquiera derechos estará sujeto a la
        previa y expresa autorización específicamente otorgada a tal efecto por la empresa o el tercero titular de los
        derechos afectados.
      </p>

      <h3>5. OBLIGACIONES Y RESPONSABILIDADES DEL USUARIO DEL ESPACIO WEB</h3>
      <p>El Usuario se compromete a:</p>
      <ul>
        <li>Hacer un uso adecuado y lícito del Espacio Web así como de los contenidos y servicios, de conformidad con:</li>
        <ul>
          <li>La legislación aplicable en cada momento;</li>
          <li>Las Condiciones Generales de Uso del Espacio Web;</li>
          <li>La moral y buenas costumbres generalmente aceptadas y el orden público.</li>
        </ul>
        <li>
          Proveerse de todos los medios y requerimientos técnicos que se precisen para acceder al Espacio Web.
        </li>
        <li>
          Facilitar información veraz al cumplimentar con sus datos de carácter personal los formularios contenidos en el
          Espacio Web y a mantenerlos actualizados en todo momento de forma que responda, en cada momento, a la situación
          real del Usuario. El Usuario será el único responsable de las manifestaciones falsas o inexactas que realice y
          de los perjuicios que cause a la empresa o a terceros por la información que facilite.
        </li>
      </ul>

      <h3>6. RESPONSABILIDADES</h3>
      <p>
        No se garantiza el acceso continuado, ni la correcta visualización, descarga o utilidad de los elementos e
        informaciones contenidas en la web que pueden verse impedidos, dificultados o interrumpidos por factores o
        circunstancias que están fuera de su control.
      </p>

      <p>
        No se hace responsable de las decisiones que pudieran adoptarse como consecuencia del acceso a los contenidos o
        informaciones ofrecidas.
      </p>

      <p>
        El servicio podrá ser interrumpido, o la relación con el Usuario resuelta de forma inmediata, si se detecta que
        un uso de su Espacio Web, o de cualquiera de los servicios ofertados en el mismo, es contrario a las presentes
        Condiciones Generales de Uso. No nos hacemos responsables por daños, perjuicios, pérdidas, reclamaciones o gastos
        derivados del uso del Espacio Web.
      </p>

      <p>
        Solo será responsable de eliminar, lo antes posible, los contenidos que puedan generar tales perjuicios, siempre
        que así se notifique. En especial no seremos responsables de los perjuicios que se pudieran derivar, entre otros,
        de:
      </p>

      <ul>
        <li>Interferencias, interrupciones, fallos, omisiones, averías telefónicas, retrasos, bloqueos o desconexiones en el funcionamiento del sistema electrónico.</li>
        <li>Intromisiones ilegítimas mediante el uso de programas malignos de cualquier tipo.</li>
        <li>Uso indebido o inadecuado del Espacio Web.</li>
        <li>Errores de seguridad o navegación producidos por un mal funcionamiento del navegador.</li>
      </ul>

      <p>
        Se exonera de responsabilidad ante cualquier daño o perjuicio que pudiera sufrir el Usuario a consecuencia de
        errores, defectos u omisiones, en la información facilitada siempre que proceda de fuentes ajenas.
      </p>

      <h3>7. POLÍTICA DE ENLACES</h3>
      <p>
        Desde el sitio web, es posible que se redirija a contenidos de terceros sitios web. Dado que no podemos controlar
        siempre los contenidos introducidos por los terceros en sus respectivos sitios web, no asumimos ningún tipo de
        responsabilidad respecto a dichos contenidos. En todo caso, procederemos a la retirada inmediata de cualquier
        contenido que pudiera contravenir la legislación nacional o internacional, la moral o el orden público,
        procediendo a la retirada inmediata de la redirección a dicho sitio web, poniendo en conocimiento de las
        autoridades competentes el contenido en cuestión.
      </p>

      <p>
        No nos responsabilizamos de la información y contenidos almacenados, a título enunciativo, pero no limitativo, en
        foros, chats, generadores de blogs, comentarios, redes sociales o cualquier otro medio que permita a terceros
        publicar contenidos de forma independiente en la página web del prestador.
      </p>

      <p>
        No obstante, y en cumplimiento de lo dispuesto en los art. 11 y 16 de la LSSICE, se pone a disposición de todos
        los usuarios, autoridades y fuerzas de seguridad, colaborando de forma activa en la retirada o, en su caso,
        bloqueo de todos aquellos contenidos que pudieran afectar o contravenir la legislación nacional o internacional,
        derechos de terceros o la moral y el orden público.
      </p>

      <h3>8. PROTECCIÓN DE DATOS</h3>
      <p>
        Se encuentra adaptado a la normativa de protección de datos personales vigente, y vela por garantizar un correcto
        uso y tratamiento de los datos personales del usuario.
      </p>

      <p>
        Para más información, consulte nuestra Política de Privacidad.
      </p>

      <h3>9. LEY APLICABLE Y JURISDICCIÓN</h3>
      <p>
        Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las
        actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las
        partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los
        Juzgados y Tribunales más cercanos a Molledo.
      </p>
    </div>
  );
};